import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import axios from 'axios';

function Preferences(){

    const [preferences,setPreferences]=useState({})

    // const column_type = {
    //       "max_leads_export": "number",
    //       "max_people_export":"number",
    //       "free_plan_limit":"number",
    //       "free_plan_age":"number",
    //       "free_plan_id":"number",
    //       "login_report_recipients":"text",
    //       "signup_report_recipients":"text",
    //       "activity_report_recipients":"text"
    // };

    const handleChange=(e) =>{
        const eDataValue = e.currentTarget.dataset.value;
        const eValue = e.target.value; 

        setPreferences((prevData) => ({
            ...prevData,
            [eDataValue]: eValue,
        }))
        
    }

    const handleSubmit=()=>{
        axios.post('/peferences',preferences)
        .then(()=>{
            alert('Preferences saved successfully')
        })
        .catch(()=>{
            alert('Something went wrong. Please try again later')
        })
    }

    useEffect(()=>{
                axios.get('/peferences')
                .then((response)=>{
                    setPreferences(response.data)
                })
        },[])

        return (<>
        <div className='mb-3'/>
        <Form>
            {Object.keys(preferences).map((p)=>(
                <Row className='mb-2'>
                    <Form.Label column lg={2}>
                    {p}
                    </Form.Label>
                    <Col>
                    <Form.Control type={(typeof preferences[p] ==="string")?"text":"number"} data-value={p} value={preferences[p]} onChange={handleChange}/>
                    </Col>
                </Row>
            ))}
            <Button variant="primary" onClick={handleSubmit} >
                Save Preferences
            </Button>
        </Form>
        </>)
}

export default Preferences;